import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import Header from '../components/Header';
import PosterBanner from '../components/PosterBanner';
import EventDetailsBox from '../components/EventDetailsBox';
import Countdown from '../components/Countdown';
import WhatToBring from '../components/WhatToBring';
import PhotoGallery from '../components/PhotoGallery';
import RegistrationButton from '../components/RegistrationButton';
import SocialSharing from '../components/SocialSharing';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import { getEvent } from '../config/events';
import '../assets/css/HomePage.css';

const EventPage = () => {
  const { eventId } = useParams();
  const event = getEvent(eventId);

  if (!event) {
    return <Navigate to="/events" replace />;
  }

  return (
    <>
      <Header />
      
      <PosterBanner event={event} />
      <EventDetailsBox event={event} />
      
      <section className="theme-header py-5 text-center">
        <div className="container">
          <h1 className="display-4 fw-bold mb-2">{event.title.toUpperCase()}</h1>
          {event.host && event.guest ? (
            <div className="mb-4">
              <div className="row justify-content-center">
                <div className="col-md-5 mb-3">
                  <div className="card shadow-lg border-0 animate-card" style={{animationDelay: '0.2s', background: `linear-gradient(135deg, ${event.theme?.primary || '#e91e63'}, ${event.theme?.secondary || '#9c27b0'})`}}>
                    <div className="card-body text-center py-4">
                      <h5 className="card-title text-white fw-bold mb-1">HOST</h5>
                      <p className="card-text text-white h4 mb-0">{event.host}</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-5 mb-3">
                  <div className="card shadow-lg border-0 animate-card" style={{animationDelay: '0.4s', background: `linear-gradient(135deg, ${event.theme?.secondary || '#9c27b0'}, ${event.theme?.primary || '#e91e63'})`}}>
                    <div className="card-body text-center py-4">
                      <h5 className="card-title text-white fw-bold mb-1">GUEST SPEAKER</h5>
                      <p className="card-text text-white h4 mb-0">{event.guest}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              <h2 className="h2 text-warning fw-bold mb-4">{event.subtitle.toUpperCase()}</h2>
              <p className="lead">{event.tagline}</p>
            </>
          )}
        </div>
      </section>
      
      <Countdown event={event} />
      {event.images?.whatToBring && <WhatToBring />}
      {event.images?.gallery && event.images.gallery.length > 0 && <PhotoGallery eventId={event.id} />}
      <RegistrationButton event={event} />
      <SocialSharing event={event} />
      <FAQ />
      
      <Footer />
    </>
  );
};

export default EventPage;